export const AI_UNAVAILABLE_MESSAGE = "AI analysis is not configured in this environment.";

export function getApiErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object") {
    if (detail.code === "AI_ANALYSIS_UNAVAILABLE") {
      return AI_UNAVAILABLE_MESSAGE;
    }
    if (typeof detail.message === "string" && detail.message.trim()) {
      return detail.message;
    }
  }
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }
  return fallback;
}
